<template>
    <div class="sportFootballMatchStatusPeriodDate">
      <span>{{ title }}</span>
      <el-date-picker v-model="dataSelected" size="mini" type="datetime" placeholder="" :clearable="false" @change="$emit('update', data)" />
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchStatusPeriodDate',
  props: {
    title: String,
    date: {
      type: Date,
      required: false
    }
  },
  data () {
    return {
      data: null
    }
  },
  computed: {
    dataSelected: {
      get () { return this.data || this.date },
      set (value) { this.data = value }
    }
  }
}
</script>

<style>
.sportFootballMatchStatusPeriodDate > span{
  position:absolute;
  display:block;
  bottom:100%;
  width:100%;
  text-align:center;
  height:12px;
  line-height: 12px;
  font-size:8px;
}
.sportFootballMatchStatusPeriodDate .el-date-editor{
  height:25px;
  width:auto;
}
.sportFootballMatchStatusPeriodDate .el-date-editor input{
  text-align: center;
  padding:0 5px;
  font-size:8px;
  background-color:var(--color-background-grey);
  border:none;
  border-radius:12px;
  height:25px;
  line-height:25px;
  width:auto;
}
.sportFootballMatchStatusPeriodDate .el-date-editor.el-input .el-input__prefix{
  display:none
}
.sportFootballMatchStatusPeriodDate .el-date-editor .el-input__icon{
  line-height:25px;
}
.sportFootballMatchStatusPeriodDate .el-date-editor .el-input__icon:before{
  color:red;
  background-color:var(--color-background-grey)
}
</style>
